import React, { Suspense } from "react";

import { LoadingModule } from "@/components";

const AccountabilityRoutesLazy = React.lazy(() => import("./AccountabilityRoutes"));

export default function RoutesLazy() {
  return (
    <Suspense fallback={<LoadingModule />}>
      <AccountabilityRoutesLazy />
    </Suspense>
  );
}
